import Loading from 'app/common/components/loading';
import { Component } from 'react';

export type LogoutProps = {
  readonly logoutUser: () => void;
};

export default class Logout extends Component<LogoutProps> {
  override componentDidMount() {
    // With Google Identity Services, there's no client-side sign out method.
    // The authentication is handled by clearing the local session.
    this.props.logoutUser();
  }

  override render() {
    return <Loading />;
  }
}
